import comp from "./ErrorCell";
export default comp;
